module.exports = __webpack_public_path__ + "static/img/pdf.c8cd3ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/file/pdf.png
// module id = 803
// module chunks = 1